import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component to prevent unauthorized access to admin routes
 * Checks for valid JWT token in localStorage
 */
export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('access_token');
  
  // If no token found, redirect to admin login
  if (!token) {
    return <Navigate to="/admin" replace />;
  }
  
  // Token exists, render the protected content
  return children;
}
